module.exports = __webpack_public_path__ + "img/19.10565d25.jpg";